import React from "react";
import Project from "../Project";

import img1 from "../../images/project images/05 Listed Building Conversion/Listed Building project.jpg"
const ListedFarmConversion = () => {
    return (
        <div>
            <Project title="LISTED FARM CONVERSION"
                location="ST. OUEN"
                image1={img1}
                description1="Masterplan and detailed design of 5 holiday apartments within a historic farm
                complex. The grade II listed farm complex required extensive repair and alterations.
                This project was undertaken whilst working at Axis Mason and planning consent was
                successfully gained."

            />
        </div>
    );

}

export default ListedFarmConversion;